import React, { PropsWithChildren } from 'react';
import { Container, Divider } from '@fiverr-private/layout_components';

type WizardHeaderProps = PropsWithChildren<{}>;

export const WizardHeader = ({ children }: WizardHeaderProps) => (
    <>
        <Container
            width="100%"
            minHeight="84px"
            display="flex"
            alignItems="center"
            paddingY="6"
            paddingX="10"
            top={0}
            left={0}
            right={0}
        >
            {children}
        </Container>
        <Divider />
    </>
);

WizardHeader.displayName = 'WizardHeader';
